var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCarbonLocationFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 2.375C15.5369 2.37909 12.2167 3.75662 9.76793 6.20543C7.31912 8.65424 5.94158 11.9744 5.9375 15.4375C5.93335 18.2676 6.85779 21.0209 8.569 23.275C8.569 23.275 8.92525 23.7441 8.98344 23.8118L19 35.625L29.0213 23.8058C29.0736 23.7429 29.431 23.275 29.431 23.275L29.4322 23.2714C31.1425 21.0183 32.0666 18.2663 32.0625 15.4375C32.0584 11.9744 30.6809 8.65424 28.2321 6.20543C25.7833 3.75662 22.4631 2.37909 19 2.375ZM19 20.1875C18.0605 20.1875 17.1422 19.9089 16.361 19.387C15.5799 18.865 14.9711 18.1232 14.6116 17.2552C14.2521 16.3873 14.158 15.4322 14.3413 14.5108C14.5245 13.5894 14.9769 12.743 15.6412 12.0787C16.3055 11.4144 17.1519 10.962 18.0733 10.7788C18.9947 10.5955 19.9498 10.6896 20.8177 11.0491C21.6857 11.4086 22.4275 12.0174 22.9495 12.7985C23.4714 13.5797 23.75 14.498 23.75 15.4375C23.7484 16.6968 23.2475 17.9041 22.357 18.7945C21.4666 19.685 20.2593 20.1859 19 20.1875Z",
    fill: "url(#paint0_linear_50:516)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_50:516",
    x1: 19,
    y1: 2.375,
    x2: 19,
    y2: 35.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33DA8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonLocationFilled);
export default __webpack_public_path__ + "static/media/carbon_location-filled.7b630d5c.svg";
export { ForwardRef as ReactComponent };